import angular from 'angular';
import reportFormat from '../reportFormat/reportFormat';
import localDateSerializer from '../../../util/LocalDateSerializer/LocalDateSerializer';
import reportTemplate from './reportTemplate.template.html';

export default angular
  .module('csm.ui.reports.reportTemplate', [reportFormat, localDateSerializer])

  /*******************************************************************************
   * Directive: reportTemplate
   *
   * Displays a template for generating reports. This will include a format selection
   * dropdown (using the reportFormat directive) and buttons for submitting the
   * request and canceling/reseting the form.
   * Elements included within the directive tag will be transcluded and rendered in
   * a div tag just above this directive's own elements.
   * Report format selection options can be hidden just as with the reportFormat directive.
   *
   * @ngdoc     directive
   * @name      reportTemplate
   * @memberof  csm.ui.reports.reportTemplate
   * @restrict  element
   *
   * @attr  {string}    reportBodyClass
   *   Optional. Space separated list of CSS classes for the body of the template
   *
   * @attr  {string}    reportDivClass
   *   Optional. Space separated list of CSS class for the div containing the label and
   *   select element. This is everything below the transcluded elements.
   *
   * @attr  {string}    reportFormatLabelClass
   *   Optional. Space separated list of CSS class for formatting the text of the
   *   report label
   *
   * @attr  {string}    reportFormatDivClass
   *   Optional. Space separated list of CSS classes for div that contains the report
   *   format select element
   *
   * @attr  {string}    reportFormatClass
   *   Optional. Space separated CSS classes for formatting the dropdown selection.
   *   These classes are passed through directly to the nested reportFormat directive
   *
   * @attr  {string}    reportControlsClass
   *   Optional. Space separated CSS classes for div containing the generate and cancel
   *   buttons
   *
   * @attr  {string}    cancelBtnClass
   *   Optional. Space separated CSS classes for the cancel button
   *
   * @attr  {boolean}   cancelBtnHide
   *   Optional. If true, the cancel button will be hidden
   *
   * @attr  {function}  cancelReport
   *   Optional. Function passed in to be executed upon the click of the cancel button
   *
   * @attr  {expression}  validateInput
   *   Optional. Expression to be executed (before submit) on click of the generate button.
   *   This is expected to return a boolean value.
   *
   * @attr  {boolean}   excludeOptions
   *   Optional. A comma separated list of values to be excluded from the reportFormat
   *   dropdown list. By default, all options are shown.
   *
   * @attr  {object}    model
   *   Required. Report request object model
   *
   * @attr  {string}    action
   *   Required. URL of the report handler
   *
   * @attr  {string}    formatLabel
   *   Label text to be displayed next to the report format select element
   *
   * @attr  {string}    cancelLabel
   *   Text for the Cancel button
   *
   * @attr  {string}    generateLabel
   *   Text for the generate button
   *******************************************************************************/
  .directive('reportTemplate', function (LocalDateSerializer) {
    return {
      scope: {
        reportBodyClass: '@',
        reportFormatLabelClass: '@',
        reportDivClass: '@',
        reportFormatDivClass: '@',
        reportFormatClass: '@',
        reportControlsClass: '@',
        cancelBtnClass: '@',
        cancelBtnHide: '=',
        cancelReport: '&',
        validateInput: '&',
        excludeOptions: '@',
        model: '=',
        action: '@',
        formatLabel: '@',
        generateLabel: '@',
        disableBtn: '&',
        cancelLabel: '@'
      },
      template: reportTemplate,

      transclude: true,
      link: function ($scope, elem, attr) {
        /*-------------------------------------------------*/
        /* Adds a listener for the form submit to perform  */
        /* any validation through the validateInput method */
        /*-------------------------------------------------*/
        elem[0]
          .querySelector('form')
          .addEventListener('submit', function (evt) {
            var validFormat = !!$scope.model.reportFormat;
            var result = $scope.validateInput();

            /*----------------------------------------------------*/
            /* Convert model to JSON string and set on form input */
            /*----------------------------------------------------*/
            LocalDateSerializer.serializeDatesOnObject($scope.model);
            angular
              .element(elem[0].querySelector('#formSubmit input[type=hidden]'))
              .val(JSON.stringify($scope.model));

            /*--------------------------------------------------------*/
            /* If no format is selected or the result from evaluating */
            /* validateInput is not true, prevent the form submission */
            /*--------------------------------------------------------*/
            var validInput = result == undefined || result;

            if (!validFormat || !validInput) evt.preventDefault();
          });
      }
    };
  }).name;
